/**
* 头部菜单
*/
<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    background-color="#006EBD"
    text-color="#fff"
    active-text-color="#fff"
  >
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
      <div class="system-name">Field Manage System</div>
    </div>

    <el-submenu index="2" class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title">
        <span class="el-icon-user-solid"></span>
        <span style="font-size: 18px">{{ user.name }}</span>
      </template>
      <el-menu-item @click="content()" index="2-2" align="center"
        >User</el-menu-item
      >
      <el-menu-item @click="exit()" index="2-3" align="center"
        >Log Out</el-menu-item
      >
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout } from "../api/userMG";
export default {
  name: "navcon",
  data() {
    return {
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: { name: "admin" },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem("userdata"));
  },
  methods: {
    // 用户信息
    content() {
      this.$notify({
        title: "message",
        message: "To Do",
        type: "warning",
      });
    },
    // 退出登录
    exit() {
      this.$confirm("log out, continue?", "notice", {
        confirmButtonText: "confirm",
        cancelButtonText: "cancel",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit("logout", "false");
            this.$router.push({ path: "/login" });
            this.$message({
              type: "success",
              message: "log out!",
            });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "cancle",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.index-header {
  border: bottom 0px;
  height: 36px;
}
.el-menu-demo {
  height: 60px;
}
.el-submenu {
  height: 36px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
  height: 36px;
}
.buttonimg {
  height: 30px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.logobox {
  position: absolute;
  top: 15px;
  left: 5px;
  height: 36px;
  text-align: center;
}
.logoimg {
  align-self: center;
  margin-left: 10px;
  height: 30px;
  width: 30px;
}
.system-name {
  font-size: 21px;
  bottom: 10px;
  color: white;
  position: absolute;
  left: 60px;
  width: 400px;
  top: 5px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue